import React, {useState} from 'react';
import { parseDateFromYYYYMMDD, formatDateToYYYYMMDD } from "../Common/Helpers";
import { Blocks } from "../Common/Interfaces";

interface Day {
    isWorkingDay: boolean;
    currentDay: boolean;
    currentMonth: boolean;
    date: Date;
    month: number;
    number: number;
    selected: boolean;
    year: number;
    dayClass: string;
}

interface CalendarDaysProps {
    day: Date;
    changeCurrentDay: (selectedDay: string) => void;
    workingDays: number[];
    blocks: Blocks[];
    nonWorkingDays: string[];
}

const CalendarDays: React.FC<CalendarDaysProps> = (props) => {
    const [selectedDay, setSelectedDay] = useState<string | null>(null);

    const firstDayOfMonth = new Date(props.day.getFullYear(), props.day.getMonth(), 1);
    const weekdayOfFirstDay = (firstDayOfMonth.getDay() + 6) % 7; // Adjust to make Monday=0, Sunday=6
    let currentDays: Day[] = [];

    let startDate = new Date(firstDayOfMonth);
    startDate.setDate(startDate.getDate() - weekdayOfFirstDay);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalize today's date to midnight to avoid time discrepancies

    const blocksWithDateObjects = props.blocks.map(block => ({
        ...block,
        date: typeof block.date === 'string' ? parseDateFromYYYYMMDD(block.date) : block.date
    }));

    for (let day = 0; day < 42; day++) {
        const formattedStartDate = formatDateToYYYYMMDD(startDate);
        const formattedToday = formatDateToYYYYMMDD(today);

        let calendarDay: Day = {
            isWorkingDay: true,
            currentDay: formattedStartDate === formattedToday,
            currentMonth: (startDate.getMonth() === props.day.getMonth()),
            date: new Date(startDate),
            month: startDate.getMonth(),
            number: startDate.getDate(),
            selected: formatDateToYYYYMMDD(startDate) === selectedDay,
            year: startDate.getFullYear(),
            dayClass: "" // Initialize dayClass
        };

        if (props.nonWorkingDays && props.nonWorkingDays.includes(formattedStartDate)) {
            calendarDay.isWorkingDay = false;
        }

        const dayBlocks = blocksWithDateObjects.filter(
            block => formatDateToYYYYMMDD(block.date) === formattedStartDate
        );

        if (dayBlocks.length > 0) {
            const allAvailable = dayBlocks.every(block => block.availability);
            const allUnavailable = dayBlocks.every(block => !block.availability);

            if (allAvailable) {
                calendarDay.dayClass = "available";
            } else if (allUnavailable) {
                calendarDay.dayClass = "unavailable";
            } else {
                calendarDay.dayClass = "mixedavailable";
            }
        }

        currentDays.push(calendarDay);
        startDate.setDate(startDate.getDate() + 1);
    }

    return (
        <div className="calendar-dates">
            {currentDays.map((day) => (
                <div
                    key={day.date.toISOString()}
                    className={
                        "calendar-day" +
                        (day.currentDay ? " current-day" : "") +
                        (day.currentMonth ? " current" : " not-current") +
                        (day.selected ? " selected" : "") +
                        (!day.isWorkingDay ? " not-working-day" : "") +
                        (day.dayClass ? ` ${day.dayClass}` : "")
                    }
                    onClick={() => {
                        if (day.currentMonth) {
                            const formattedDate = `${day.year}${String(day.month + 1).padStart(2, '0')}${String(day.number).padStart(2, '0')}`;
                            setSelectedDay(formattedDate);
                            props.changeCurrentDay(formattedDate);
                        }
                    }}>
                    <p>{day.number}</p>
                </div>
            ))}
        </div>
    );
};

export default CalendarDays;
